import { render } from "./workOrderHistoryList.vue?vue&type=template&id=dd00cd10"
import script from "./workOrderHistoryList.vue?vue&type=script&lang=js"
export * from "./workOrderHistoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__